import { Paragraph, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  pdfName?: string;
  notes?: string;
  quantity?: string;
  pdfRecreatedCount?: string;
};

const PdfInformation = ({
  pdfName,
  notes,
  quantity,
  pdfRecreatedCount,
}: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PDF INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            PDF Name :
          </Typography>
          <Typography className="value">{pdfName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Printing Quantity :
          </Typography>
          <Typography className="value">{quantity}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            PDF Recreated Count :
          </Typography>
          <Typography className="value">{pdfRecreatedCount}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title" fontColor="dark">
            Notes :
          </Typography>
          <div>
            <Paragraph className="value" text={notes} />
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default PdfInformation;
